export const DATA_EXPLORER_APPEARANCE_OPTIONS = Object.freeze({
  surface: ['card', 'flush'] as const,
  preset: [
    'default',
    'soft',
    'compact',
    'tinted-glass',
    'flat',
    'glass',
    'hard-edge',
  ] as const,
  density: ['compact', 'default', 'comfortable'] as const,
  radius: ['none', 'sm', 'md', 'lg', 'xl', 'full'] as const,
  border: ['none', 'subtle', 'solid', 'strong'] as const,
  background: ['plain', 'muted', 'soft', 'glass', 'dark-stage'] as const,
});
